// ===========================================================================
// ClinicalProfile — perfil clínico de la ficha: condiciones (conductuales
// destacadas arriba) + Health Status actual.
// ===========================================================================
import React, { useMemo } from "react";
import { Box, Paper, Typography, Stack, Chip } from "@mui/material";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { HEALTH_STATUS_COLORS } from "../../common/constants";

export default function ClinicalProfile({ conditions, header }) {
  // El backend ya ordena conductuales primero; reforzamos defensivamente.
  const sorted = useMemo(() => {
    const list = Array.isArray(conditions) ? [...conditions] : [];
    return list.sort((a, b) => Number(b.behavioral) - Number(a.behavioral));
  }, [conditions]);

  const hsColor = HEALTH_STATUS_COLORS[header?.healthStatus] || "#9e9e9e";

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, mb: 2.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Clinical profile
        </Typography>
        <Chip
          label={`${header?.healthStatus || "—"} · GI ${header?.globalIndicator ?? "—"}`}
          size="small"
          sx={{ color: "#fff", bgcolor: hsColor, fontWeight: 600 }}
        />
      </Stack>

      {sorted.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No conditions recorded.
        </Typography>
      ) : (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {sorted.map((c, i) => (
            <Chip
              key={`${c.conditionName}-${i}`}
              icon={c.behavioral ? <PsychologyIcon /> : undefined}
              label={c.conditionName}
              size="small"
              color={c.behavioral ? "secondary" : "default"}
              variant={c.behavioral ? "filled" : "outlined"}
            />
          ))}
        </Stack>
      )}
    </Paper>
  );
}
